module.exports = __webpack_public_path__ + "static/media/FlagMx.ce6187f5.svg";